import { useEffect, useRef } from "react";
import ChatItem from "./chat-item";
import { Text } from "../ui/text";
import { useChatsQuery } from "@/hooks/services/queries/ai-agent/use-chats-query";

const ChatList = () => {
  const {
    data,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    isLoading,
  } = useChatsQuery();

  const scrollRef = useRef<HTMLUListElement>(null);
  const observerRef = useRef<IntersectionObserver | null>(null);
  const loadMoreRef = useRef<HTMLDivElement>(null);

  // 무한 스크롤 설정
  useEffect(() => {
    if (!loadMoreRef.current) return;

    observerRef.current = new IntersectionObserver(
      (entries) => {
        const firstEntry = entries[0];
        if (firstEntry.isIntersecting && hasNextPage && !isFetchingNextPage) {
          fetchNextPage();
        }
      },
      {
        root: scrollRef.current,
        threshold: 0.1,
      }
    );

    observerRef.current.observe(loadMoreRef.current);

    return () => {
      if (observerRef.current) {
        observerRef.current.disconnect();
      }
    };
  }, [hasNextPage, isFetchingNextPage, fetchNextPage]);

  // 모든 페이지의 채팅을 평탄화
  const allChats = data?.pages.flatMap((page) => page.content) ?? [];

  return (
    <div className="flex flex-col gap-2 px-2">
      <Text variant={"title-md"}>Recent</Text>
      <ul
        ref={scrollRef}
        className="flex flex-col h-[600px] overflow-y-auto"
      >
        {isLoading ? (
          <div className="flex justify-center items-center py-4">
            <div className="w-6 h-6 border-2 border-primary-80 border-t-primary-40 rounded-full animate-spin"></div>
          </div>
        ) : (
          <>
            {allChats.map((chat) => (
              <ChatItem key={chat.chatId} chatItem={chat} />
            ))}
            {/* 무한 스크롤 트리거 */}
            <div ref={loadMoreRef} className="h-4">
              {isFetchingNextPage && (
                <div className="flex justify-center items-center py-2">
                  <div className="w-4 h-4 border-2 border-primary-80 border-t-primary-40 rounded-full animate-spin"></div>
                </div>
              )}
            </div>
          </>
        )}
      </ul>
    </div>
  );
};

export default ChatList;
